var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilsquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pencil square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.502 1.94003C15.5954 2.03375 15.6479 2.16069 15.6479 2.29303C15.6479 2.42536 15.5954 2.5523 15.502 2.64603L14.459 3.69003L12.459 1.69003L13.502 0.646027C13.5957 0.552292 13.7229 0.499634 13.8555 0.499634C13.988 0.499634 14.1152 0.552292 14.209 0.646027L15.502 1.93903V1.94003ZM13.752 4.39603L11.752 2.39603L4.93896 9.21003C4.88392 9.26505 4.84249 9.33217 4.81796 9.40603L4.01296 11.82C3.99836 11.864 3.99629 11.9112 4.00697 11.9564C4.01766 12.0015 4.04068 12.0427 4.07347 12.0755C4.10625 12.1083 4.14751 12.1313 4.19263 12.142C4.23775 12.1527 4.28495 12.1506 4.32896 12.136L6.74296 11.331C6.81672 11.3068 6.88383 11.2657 6.93896 11.211L13.752 4.39703V4.39603Z",
    fill: "#007BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 13.5C1 13.8978 1.15804 14.2794 1.43934 14.5607C1.72064 14.842 2.10218 15 2.5 15H13.5C13.8978 15 14.2794 14.842 14.5607 14.5607C14.842 14.2794 15 13.8978 15 13.5V7.5C15 7.36739 14.9473 7.24021 14.8536 7.14645C14.7598 7.05268 14.6326 7 14.5 7C14.3674 7 14.2402 7.05268 14.1464 7.14645C14.0527 7.24021 14 7.36739 14 7.5V13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9473 13.6326 14 13.5 14H2.5C2.36739 14 2.24021 13.9473 2.14645 13.8536C2.05268 13.7598 2 13.6326 2 13.5V2.5C2 2.36739 2.05268 2.24021 2.14645 2.14645C2.24021 2.05268 2.36739 2 2.5 2H9C9.13261 2 9.25979 1.94732 9.35355 1.85355C9.44732 1.75979 9.5 1.63261 9.5 1.5C9.5 1.36739 9.44732 1.24021 9.35355 1.14645C9.25979 1.05268 9.13261 1 9 1H2.5C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V13.5Z",
    fill: "#007BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilsquare);
export default __webpack_public_path__ + "static/media/Pencil square.2f23e613891574e753a0fef3ce2a47b6.svg";
export { ForwardRef as ReactComponent };